<template>
<div style="height: 100%">
    <app-base-main parentTable>
      <template #filter-group>
        <app-filter-group
          @query="$gjNoticeQuery"
          @reset="$gjReset">
          <gj-warehouse-select v-model="filter.warehouseIds" :self="false" multiple width="180px"></gj-warehouse-select>
          <gj-select-input
            v-model="filter.keyword"
            :options="[
              {id: 'shipmentId', text: 'ShipmentID'},
              {id: 'name', text: '货件名称'},
              {id: 'centerId', text: '亚马逊仓代码'},
              {id: 'shipPlanCode', text: '发货计划'},
              {id: 'logisticsCode', text: '物流跟踪号'},
            ]"
            :width="['120px', '120px']">
          </gj-select-input>
          <gj-select-input
            v-model="filter.keyword1"
            :options="[
              {id: 'msku', text: 'MSKU'},
              {id: 'fnsku', text: 'FNSKU'},
              {id: 'asin', text: 'ASIN'},
            ]"
            :width="['90px', '100px']">
          </gj-select-input>
          <gj-select
            v-model="filter.status"
            :options="FbaShipmentEnum.statusOption"
            multiple
            collapse-tags
            placeholder="状态"
            :width="clientWidth>1366?'191px':'170px'">
          </gj-select>
          <gj-country-select v-model="filter.country" multiple collapse-tags></gj-country-select>
          <gj-select-date-picker
            type="daterange"
            v-model="filter.date"
            :options="[
              {id: 'Create', text: '创建时间'},
              {id: 'Update', text: '更新时间'},
            ]"
            @prefix-change="changeDateType">
          </gj-select-date-picker>
          <template #right>
            <view-setting
              :ref="REF_VIEW_SETTING"
              save-mode="remote"
              :use-default="true"
              :module-name="moduleName"
              :config="model"
              :fn-generate-params="generateViewParams"
              @view-change="handleChangeView"
              @view-complete="handCompleteView">
            </view-setting>
          </template>
        </app-filter-group>
      </template>
      <template #operate-group>
        <gj-button v-if="$permission('shipment:add')" type="primary" @click="add">创建货件</gj-button>
        <gj-button v-if="$permission('shipment:sync')" @click="sync">同步货件</gj-button>
        <gj-button v-if="$permission('shipment:printBoxMark')" :disabled="!printBoxMarkDisabled" @click="printBoxMark"> 打印箱唛</gj-button>
        <!-- <gj-button v-if="$permission('shipment:printLabels')" :disabled="noSelect" @click="printLabel">打印商品标签</gj-button> -->
        <gj-dropdown-button v-if="$permission('shipment:printLabels')" :disabled="noSelect" placement="bottom-start">
          批量打印
          <template #dropdown>
            <gj-dropdown-item @click="printLabel(selectedRows)">商品标签打印(模板)</gj-dropdown-item>
            <gj-dropdown-item @click="customPrint(selectedRows)">商品标签打印(自定义)</gj-dropdown-item>
          </template>
        </gj-dropdown-button>
        <gj-button
          v-if="$permission('shipNote:add')"
          @click="openGenerateShipment"
          :disabled="noSelect || selectedSomeIn('status', [FbaShipmentEnum.status.DELETED, FbaShipmentEnum.status.CANCELLED])">
          生成发货单
        </gj-button>
      </template>
      <template #tool-group>
        <gj-tool-group help></gj-tool-group>
      </template>
      <template #table>
        <gj-expand-table
          ref="gjTable"
          :list="tableData"
          :columns="columns"
          :loading="loading"
          highlight-hover-row
          selection
          :show-overflow="false"
          :pagerConfig="pagination"
          :default-sort="{prop: 'updateTime', order: 'descending'}"
          :expand-config="{span: [1,6], children: 'items'}"
          @sort-change="$gjSortChange"
          @page-change="$gjNoticeQuery">
          <template #image="{row}">
            <!-- 先扩展收起 -->
            <template v-if="row.isExpandRow">
              <div class="expend-row">
                <div v-if="!row.isExpand">
                  <gj-link type="default" @click="openDetail(row,true)">
                    更多（共{{ row.num }}条）
                    <i class="iconfont iconzhankai"></i>
                  </gj-link>
                </div>
                <div v-else>
                  <gj-link type="default" @click="openDetail(row, false)">
                    收起
                    <i class="iconfont iconshouqi"></i>
                  </gj-link>
                </div>
              </div>
            </template>
            <template v-else>
              <template v-if="row.isParent">
                <div class="flex align-center" style="flex-wrap: wrap">
                  <div style="display: inline-block;width: 130px;">
                    {{ row.shipmentId }}
                    <span v-copy="row.shipmentId" class="copy-icon gj-cell-display-switch">
                    <gj-icon class="el-icon-copy-document"></gj-icon>
                  </span>
                  </div>

                  <div class="marginRight20">
                    <span style="color: #999999;">仓库：</span>{{ row.warehouseName }}
                  </div>
                  <gj-tag type="plain" shape="rectangle"
                          :color="row.status | optionColor(FbaShipmentEnum.statusOption)">
                    {{ row.status | optionText(FbaShipmentEnum.statusOption) }}
                  </gj-tag>
                   <i v-if="row.status === FbaShipmentEnum.status.WORKING" class="iconfont iconshuaxin" :class="{'rote360': row.refreshLoading}" style="color: blue;" @click="refresh(row)"></i>
                  <div class="marginRight20" style="margin-left: 10px;">
                    <span style="color: #999999;">亚马逊仓代码: </span>
                    {{ row.centerId }}
                  </div>
                  <div class="marginRight20">{{ row.shipToCountryCode | optionText(countryOption) }}</div>
                  <div class="marginRight20">
                    <span style="color: #999999;">货件名称：</span>
                    <gj-text :content="row.name" max-width="120px">{{ row.name | defaultShow }}</gj-text>
                  </div>
                  <div class="marginRight20">
                    包装明细：
                    <gj-tag type="text" :color="row.fbaPackage | optionColor(FbaShipmentEnum.listFbaPackageOption)">
                      {{ row.fbaPackage | optionText(FbaShipmentEnum.listFbaPackageOption) }}
                    </gj-tag>
                  </div>
                  <div class="marginRight20" v-if="row.logisticsCodes">
                   物流跟踪号：
                   <span v-if="row.logisticsCodes.length == 0" style="color: #999999;">未上传</span>     
                   <span v-else-if="row.logisticsCodes.length == 1">{{ row.logisticsCodes | defaultShow }}</span>
                   <el-tooltip v-else placement="top">
                    <div slot="content">
                      <div v-for="item in row.logisticsCodes" :key="item">跟踪号：{{item}}</div>
                    </div>
                    <el-button type="text" style="color: black; font-size: 12px;">{{row.logisticsCodes[0]}}<i class="iconfont icona-Group284" style="color:#000; margin-left: 5px;"></i></el-button>
                  </el-tooltip>
                    <!-- <gj-text v-else max-width="100px" :content=" row.logisticsCodes[0]">
                       {{row.logisticsCodes[0]}}
                    </gj-text> -->
                 </div>

                </div>
              </template>
              <template v-else>
                <gj-image :src="row.skuImageUrl"></gj-image>
              </template>
            </template>
          </template>
          <template #sku="{row}">
            <RelateProductComponent :data="{sku: row.sku, msku: row.msku, marketId: row.marketId}"></RelateProductComponent>
          </template>
          <template #skuName="{row}">
            <gj-tooltip :text-line="2" :content="row.skuName">
              {{ row.skuName }}
            </gj-tooltip>
          </template>
          <template #msku="{row}">
            <gj-tooltip :text-line="2" :content="row.msku">
              {{ row.msku }}
            </gj-tooltip>
          </template>
          <template #shipPlanCodeList="{row}">
            <template v-if="!row.isParent">
              <template v-if="row.shipPlanCodeList && row.shipPlanCodeList.length !== 0">
                <el-dropdown>
                  <span class="el-dropdown-link" style="font-size: 12px;">
                    {{ row.shipPlanCodeList[0] | defaultShow }}
                    <i v-if="row.shipPlanCodeList.length > 1" class="el-icon-arrow-down el-icon--right"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <template v-if="row.shipPlanCodeList.length > 1">
                      <template v-for="(item,key) in row.shipPlanCodeList">
                        <el-dropdown-item :key="key">
                          <span style="font-size: 12px;">{{ item }}</span>
                        </el-dropdown-item>
                      </template>
                    </template>
                  </el-dropdown-menu>
                </el-dropdown>
              </template>
              <template v-else>
                -
              </template>
            </template>
          </template>
          <template #op="{index,row}">
            <template v-if="row.isParent">
              <template v-if="row.status === FbaShipmentEnum.status.WORKING">
                <gj-button-group type="dropdown-op">
                  <gj-button type="text" @click="view(row)">
                    详情
                  </gj-button>
                  <gj-button v-if="$permission('shipment:edit')" type="text" @click="handle(row)">
                    处理货件
                  </gj-button>
                  <template v-if="$permission('shipment:delete')" #dropdown>
                    <gj-dropdown-item type="text" @click="deleteItem(row, index)">
                      删除
                    </gj-dropdown-item>
                  </template>
                </gj-button-group>
              </template>
               <template v-else-if="(row.status === FbaShipmentEnum.status.READY_TO_SHIP || row.status === FbaShipmentEnum.status.SHIPPED || row.status === FbaShipmentEnum.status.IN_TRANSIT || row.status === FbaShipmentEnum.status.DELIVERED  || row.status === FbaShipmentEnum.status.CHECKED_IN || row.status === FbaShipmentEnum.status.RECEIVING)">
                  <gj-button type="text" @click="view(row)">详情</gj-button>
                  <gj-button type="text" @click="addLogisticsModal(row)">录入物流跟踪号</gj-button>
              </template>

              <template v-else>
                <gj-button type="text" @click="view(row)">
                  详情
                </gj-button>
              </template>
            </template>
          </template>
        </gj-expand-table>
      </template>
    </app-base-main>
     <!-- 录入物流跟踪号  -->
    <gj-modal
        :visible.sync="addLogisticsFlag"
        notFooterPadding
        :confirm-loading="addLoading"
        @cancel="editCancel"
        @confirm="editConfirm"
        size="normal"
    >
    <template #header>
        <span>录入物流跟踪号</span>
    </template>
    <template #content>
        <div>
          <gj-input
              v-model="logisticsValue"
              :width="'460px'"
              placeholder="请输入物流跟踪号,多个跟踪号请用逗号隔开"
          ></gj-input>
          <p style="color: red;">注：一个货件对应多个发货单可录入多个物流跟踪号，但不可删除，请谨慎操作！</p>
        </div>
    </template>
    </gj-modal>
        <!-- ready to ship提示  -->
    <gj-modal
        :visible.sync="readyShipFlag"
        notFooterPadding
        size="normal"
    >
    <template #content>
        <div>
          <p style="font-weight: bold; color: black;">ready to ship状态同步:</p>
          <p>ready to ship状态货件可通过刷新working状态获取，点击后系统将实时同步亚马逊后台货件状态，若同步失败请确认亚马逊后台货件状态或稍后再次刷新请求，请勿频繁点击。</p>
        </div>
    </template>
    <template #footer>
      <gj-button
          class="btn"
          style="font-size: 12px;"
          @click="cancel"
          type="primary"
      >我知道了
      </gj-button>
    </template>
    </gj-modal>
</div>
</template>

<script>
  import AppSyncFbaShipmentModal from "./modal/sync-fba-shipment-modal";
  import {defaultVal, isMeaningful} from "@/utils/common";
  import AppPrintBoxMarkModal from "./modal/print-box-mark-modal";
  import AppPrintLabelModal from "./modal/print-label-modal";
  import AppViewFbaShipmentModal from "../../common/logistics/view-fba-shipment-modal";
  import AppHandleFbaShipmentModal from "./modal/handle/handle-fba-shipment-modal";
  import AppLabelPrintModal from '@/views/components/label-print-modal/label-print-modal';
  import {queryMixin, responseMixin, selectionMixin, isMeaningfulMixin} from "@/minxins";
  import {convertToDate, generateViewParams} from "@/utils/date.util";
  import {deleteFbaShipment, getFbaShipmentPage, shipmentLogistics, syncFbaShipment} from "@/api/logistics";
  import {countryOption} from "@/utils/options";
  import {FbaShipmentEnum} from "../../common/logistics/enum";
  import model from './viewConfig'
  import { mapGetters } from 'vuex';
  import AppGenerateShipment from '../../common/logistics/shipment-bill/shipment-bill-generate';
  import { RelateProductComponent, disconnectRelateProduct }from '@/views/components/relate-product/index';
  import {editUserConfig} from "@/api/user";
  import {getAllMap} from "@/api/dashboard";
  export default {
    name: "app-fba-shipment",
    mixins: [queryMixin, selectionMixin, responseMixin, isMeaningfulMixin],
    components: {
      RelateProductComponent,
    },
    data() {
      return {
        tableName: 'fbaShipment',
        tableData: [],
        filter: {
          warehouseIds: [],
          keyword: {
            key: 'shipmentId',
            value: null
          },
          keyword1: {
            key: 'msku',
            value: null
          },
          status: [],
          country: [],
          date: {
            key: 'Update',
            value: null
          },
        },
        FbaShipmentEnum: FbaShipmentEnum,
        countryOption: countryOption,
        moduleName: 'FBA_SHIPMENT',
        model,
        columns: [
          { id: 'picture', title: '图片', field: 'imageUrl', width: '50px', slots: { default: 'image' } },
          { id: 'sku', title: 'SKU', field: 'sku', minWidth: '120px', slots: { default: 'sku' } },
          { id: 'skuName', title: '产品名称', field: 'skuName', minWidth: '200px', slots: { default: 'skuName' } },
          { id: 'msku', title: 'MSKU', field: 'msku', minWidth: '120px', slots: { default: 'msku' } },
          { id: 'asin', title: 'ASIN', field: 'asin', minWidth: '120px' },
          { id: 'fnsku', title: 'FNSKU', field: 'fnsku', minWidth: '120px' },
          { id: 'quantityShipped', title: '申报量', field: 'quantityShipped', width: '100px', align: 'right' },
          { id: 'quantityReceived', title: '收货量', field: 'quantityReceived', width: '100px', align: 'right' },
          { id: 'shipQuantity', title: '已发量', field: 'shipQuantity', width: '100px', align: 'right' },
          { id: 'diffValue', title: '申收差异', field: 'diffValue', width: '120px', align: 'right' },
          { id: 'shipPlanCodeList', title: '发货计划编号', field: 'shipPlanCodeList', width: '160px', align: 'right', slots: { default: 'shipPlanCodeList' } },
          { id: 'createTime', title: '创建时间', field: 'createTime', minWidth: '160px', sortable:true },
          { id: 'updateTime', title: '更新时间', field: 'updateTime', minWidth: '160px', sortable:true },
          { id: 'op', title: '操作', field: 'op', width: '200px', slots: { default: 'op' }, fixed: 'right' }
        ],
        addLogisticsFlag: false,
        logisticsValue: null,
        addLoading: false,
        inputItem: null,
        readyShipFlag: false,
        readyToShip: '',

      }
    },
    computed: {
      ...mapGetters({
        marketOption: 'marketOption',
      }),
      printBoxMarkDisabled() {
        return this.hasSelect;
      }
    },
    created() {
      this.sort.prop = 'updateTime';
      getAllMap().then(data => {
        this.readyToShip = data?.readyToShip ?? 'show';
        if (this.readyToShip != 'hide') {
          this.readyShipFlag = true
        }
      }).catch(err => {
   
      })
    },
    activated() {
      const isrefresh = sessionStorage.getItem('fba-shipment-refresh')
      if (isrefresh) {
        this.$gjResetPage();
        sessionStorage.removeItem('fba-shipment-refresh')
      }
    },
    methods: {
      generateViewParams,
      /**
       * 设置全局查询参数
       */
      mergeRemoteParams (params) {
        const date = params.date ? params.date : [params.startDateTime, params.endDateTime]
        this.filter = Object.assign({}, this.filter, {
          ...params,
          date: {
            key: 'Update',
            value: date
          }
        })
      },
      loadViewComplete () {
        this.$emit('query')
      },
      $gjQueryInitParams() {
        return {
          filter: {
            warehouseIds: [],
            keyword: {
              key: 'shipmentId',
              value: null
            },
            keyword1: {
              key: 'msku',
              value: null
            },
            status: null,
            country: null,
            date: {
              key: 'Update',
              value: null
            },
          },
        };
      },
      $gjQuery() {
        // 构造查询参数
        const params = {
          model: {
            warehouseIds: this.filter.warehouseIds,
            countryCodes: defaultVal(this.filter.country, []),
            statusList: defaultVal(this.filter.status, [])
          },
          ...this.queryPagination,
          ...this.querySort
        };
        if (isMeaningful(this.filter.date.value)) {
          params.model['start' + this.filter.date.key + 'Time'] = convertToDate(this.filter.date.value[0]);
          params.model['end' + this.filter.date.key + 'Time'] = convertToDate(this.filter.date.value[1]);
        }
        params.model[this.filter.keyword.key] = defaultVal(this.filter.keyword.value, null);
        params.model[this.filter.keyword1.key] = defaultVal(this.filter.keyword1.value, null);
        this.globalParams = params;
        // 查询
        this.loading = true;
        getFbaShipmentPage(params)
          .then((data) => {
            this.tableData = data.records.map((v, i) => {
              const items = this._.cloneDeep(v.items)?.map(e => ({
                ...e,
                marketId: v.marketId
              }))
              return Object.assign(v, {
                itemCopy: items||[],
                items: items ? items.slice(0, 3) : [],
                isExpand:false,
                hasExpand:false,
                refreshLoading: false
              })
            });
            this.tableData.forEach(item => item.items.forEach(childItem => {
              childItem.marketId = item.marketId;
            }));
            this.pagination = this.getPagination(data);
          })
          .complete(() => {
            this.loading = false;
          });
      },
      sync() {
        this.$gjCreate(AppSyncFbaShipmentModal, {
          on: {
            created: () => {
              this.$gjResetPage();
            }
          }
        });
      },
      printBoxMark() {
        const modal = this.$gjCreate(AppPrintBoxMarkModal, {
          props: {
            shipments: this.selectedRows,
          }
        });
      },
      printLabel() {
        this.$gjCreate(AppPrintLabelModal, {
          props: {
            ids: this.selectedRows.map(item => item.id)
          }
        });
      },
      customPrint(rows) {
        this.$gjCreate(AppLabelPrintModal, {
          props: {
            source: 'fba',
            mode: 'interface',
            params: {
              ids: rows.map(item => item.id).join(',')
            },
            items: rows,
            columns: [
              {id: 'picture', header: '图片', field: 'picture:listingImageUrl', minWidth: '60px'},
              {id: 'asin', header: 'ASIN/MSKU', field: 'slot:asin', minWidth: '120px'},
              {id: 'fnsku', header: 'FNSKU', field: 'slot:fnsku', minWidth: '100px'},
              {id: 'title', header: '商品标题', field: 'slot:title', minWidth: '130px' },
              {id: 'titlePrint', header: '商品标题(打印)', field: 'slot:titlePrint', minWidth: '120px'},
              {id: 'productName', header: '产品名称/SKU', field: 'slot:productName', minWidth: '100px'},
              {id: 'marketId', header: '店铺/国家', field: 'option:marketId', minWidth: '80px', options: () => this.marketOption,},
              {id: 'shipmentId', header: '货件号', field: 'shipmentId', minWidth: '80px'},
              {id: 'quantityShipped', header: '申报量', field: 'quantityShipped', minWidth: '80px',},
              {id: 'printCount', header: 'slot:printCount', field: 'slot:printCount', align: 'left', width: '140px'},
              {id: 'op', header: '操作', field: 'slot:op', minWidth: '80px', fixed: 'right', notCustomColumn: true, }
            ]
          },
        });
      },
      view(shipment) {
        this.$gjCreate(AppViewFbaShipmentModal, {
          props: {
            id: shipment.id,
            shipmentId: shipment.shipmentId,
            warehouseId: shipment.warehouseId
          }
        });
      },
      handle(row) {
        this.$gjCreate(AppHandleFbaShipmentModal, {
          props: {
            id: row.id,
            shipmentId: row.shipmentId
          },
          on: {
            updated: () => {
              this.$gjResetPage();
            },
            markShipment: () => {
              this.$gjResetPage();
            }
          }
        });
      },
      deleteItem(row) {
        const modal = this.$gjCreate('gj-info-modal', {
          props: {
            title: '删除确认',
            content: `确认删除[${row.name}]？`
          },
          on: {
            cancel: () => modal.$gjDestroy(),
            confirm: () => {
              modal.confirmLoading = true;
              deleteFbaShipment(row.id)
                .then((res) => {
                  this.$gjResponseHandle(res, () => {
                    this.$gjMessage.success('删除成功');
                    this.$gjResetPage();
                    modal.$gjDestroy();
                  });
                })
                .complete(() => modal.confirmLoading = false);
            }
          }
        });
      },
      add() {
        this.$router.push({path: '/logistics/fba-shipment-add'})
        // this.$gjCreate(AddFbaShipmentModal, {
        //   on: {
        //     created: () => {
        //       this.$gjResetPage();
        //     }
        //   }
        // });
      },
      viewLog() {
        this.$gjCreate('gj-log-modal', {
          props: {
            url: '',
          }
        });
      },
      openGenerateShipment() {
        const modal = this.$gjCreate(AppGenerateShipment, {
          props: {
            shipmentIds: this.selectedRows.map(v => v.id)
          },
          on: {
            after: () => {
              this.$gjResetPage();
              modal.$gjDestroy();
            }
          }
        })
      },
      /**
       * 解除关联
       */
      disconnect(id) {
        disconnectRelateProduct.call(this, id)
      },
      openDetail(row, isExpand){
        row.isExpand = isExpand;
        if (isExpand) {
          row.items = row.itemCopy;
        } else {
          row.items = row.itemCopy.slice(0,3);
        }
        this.tableData = this.tableData.map(v => {
          if (v.id === row.id) {
            v.isExpand = row.isExpand
            v.items = row.items
          }
          return v
        })
      },
      /**
       * 时间类型切换
       */
      changeDateType(value) {
        this.sort.prop = value.key.toLowerCase() + 'Time'
      },
      refresh(row) {
        row.refreshLoading = true
        // working状态货件新增状态刷新按钮
         syncFbaShipment({
            marketId: row.marketId || "",
            shipmentIds: [row.shipmentId]
          }).then(res => {
            if (res.code == 0) {
              this.$gjMessage.success(res.data || '同步成功');
              this.$gjQuery()
            }
            
          }).complete(() => {row.refreshLoading = false});
     
      },
      addLogisticsModal(row) {
        // this.readyShipFlag = true;
        this.inputItem = row;
        this.addLogisticsFlag = true;
          
      },
       editConfirm() {
         if (this.logisticsValue == null) {
            this.$gjMessage.warning("没有输入跟踪号");
           return
         }
          let logisticsStr = this.logisticsValue.replace(/\s*/g,"");
          var logisticsList = logisticsStr.split(/[,，;:：/]/);
          if (logisticsStr.length == 0) {
            this.$gjMessage.warning("没有输入跟踪号或只输入了空格");
            return
          }
          this.addLoading = true
           const params = {
             storageShipmentId:  this.inputItem.shipmentId,
             logisticsCodeList: logisticsList
          };
          shipmentLogistics(params).then(res => {
              if (res.code == 0) {
                this.$gjMessage.success("录入物流跟踪号成功");
                this.$gjQuery();
                this.logisticsValue = null;
              }

          }).complete(() => {
            this.addLoading = false
            this.addLogisticsFlag = false
          })

       },
       editCancel() {
         this.logisticsValue = null;
          this.addLogisticsFlag = false;
        },
        cancel() {
          this.noReadyShipTip();          
        },
        async noReadyShipTip(){
          await editUserConfig({
            name: 'readyToShip',
            value: 'hide'
          }).then(res => {
            this.readyToShip = 'hide'
            this.readyShipFlag = false
          })
        },
    
    }
  }
</script>

<style lang="scss" scoped>
.iconfont{
  font-size: 10px;
  color: #999;
}
.iconshouqi{
  margin-left: 5px;
}
/deep/ .gj-link{
  &:hover{
    .iconfont{
      color: #1F6EEF;
    }
  }
}
.marginRight20{
  margin-right: 20px;
}

/deep/ .iconshuaxin {
  margin: 0 20px 0 5px;
  font-size: 14px;
  color: #999;
  cursor:pointer;
  position: relative;
}

.rote360 {
  animation: rote360 0.8s linear infinite;
}

@keyframes rote360 {
    from{}
    to{
    transform: rotate(360deg);
    }
  }

</style>

